import React, { useEffect, useState } from 'react';
import { MapPin, Building2 } from 'lucide-react';
import customerFeaturesService, { CustomerFeatures } from '../services/customerFeaturesService';
import siteService from '../services/siteService';
import locationService, { LocationDropdownItem } from '../services/locationService';

interface Props {
  selectedSiteId: string;
  selectedLocationId: string;
  onSiteChange: (v: string) => void;
  onLocationChange: (v: string) => void;
  // 'all' varsayilan; sadece list gorunumunde ekstra 'Tumu' secenegi
  className?: string;
}

const SiteLocationFilter: React.FC<Props> = ({
  selectedSiteId, selectedLocationId, onSiteChange, onLocationChange, className = ''
}) => {
  const [features, setFeatures] = useState<CustomerFeatures | null>(null);
  const [sites, setSites] = useState<{ id: number; name: string }[]>([]);
  const [locations, setLocations] = useState<LocationDropdownItem[]>([]);

  useEffect(() => {
    (async () => {
      const f = await customerFeaturesService.get();
      setFeatures(f);
      if (f.sites) {
        const s = await siteService.getDropdown();
        if (s.success && s.data) setSites(s.data.map(x => ({ id: x.id, name: x.name })));
      }
      const l = await locationService.getForDropdown();
      if (l.success && l.data) setLocations(l.data);
    })();
  }, []);

  const showSites = features?.sites === true;
  const siteLabel = features?.siteLabelPlural || 'Şantiyeler';

  return (
    <div className={`flex flex-wrap gap-2 items-center ${className}`}>
      {showSites && sites.length > 0 && (
        <div className="relative">
          <Building2 size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
          <select
            value={selectedSiteId}
            onChange={(e) => onSiteChange(e.target.value)}
            className="pl-9 pr-8 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 focus:ring-2 focus:ring-blue-500 focus:outline-none appearance-none min-w-[180px]"
          >
            <option value="all">Tüm {siteLabel}</option>
            {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
      )}
      {locations.length > 0 && (
        <div className="relative">
          <MapPin size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
          <select
            value={selectedLocationId}
            onChange={(e) => onLocationChange(e.target.value)}
            className="pl-9 pr-8 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 focus:ring-2 focus:ring-blue-500 focus:outline-none appearance-none min-w-[180px]"
          >
            <option value="all">Tüm Lokasyonlar</option>
            {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
          </select>
        </div>
      )}
    </div>
  );
};

export default SiteLocationFilter;
